// kaching-live: pinta en las landings el widget de Kaching tal como está HOY en el PDP.
// Uso en el body de la page (dentro del <form action="/cart/add">):
//   <div data-kaching-live="energy-strips"></div>
//   <script type="module" src=".../kaching-live.js"></script>
// El loader/CSS/config de Kaching ya los pone el app embed global en todas las páginas.
const hosts = document.querySelectorAll('[data-kaching-live]:not([data-kl-done])');
for (const host of hosts) {
  host.dataset.klDone = '1';
  const handle = host.dataset.kachingLive;
  try {
    const res = await fetch(`/products/${handle}`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(res.status);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const block = doc.querySelector('kaching-bundle');
    if (!block) throw new Error('sin kaching-bundle');
    const frag = document.createDocumentFragment();
    const seen = new Set();
    doc.querySelectorAll('script.kaching-bundles-product, script.kaching-bundles-deal-block-settings').forEach((s) => {
      const key = s.className + '|' + s.dataset.productId + '|' + s.textContent.length;
      if (seen.has(key)) return;
      seen.add(key);
      const n = document.createElement('script');
      for (const a of s.attributes) n.setAttribute(a.name, a.value);
      n.textContent = s.textContent;
      frag.appendChild(n);
    });
    const kb = document.createElement('kaching-bundle');
    for (const a of block.attributes) kb.setAttribute(a.name, a.value);
    frag.appendChild(kb);
    host.replaceChildren(frag);
  } catch (e) {
    console.warn('kaching-live', handle, e);
    host.innerHTML = `<a href="/products/${handle}" style="display:block;text-align:center;padding:16px;font-weight:700">Ver ofertas</a>`;
  }
}
